:host {
  display: block;
}

cwru-form,
cwru-form cwru-form-question,
cwru-form cwru-form-label,
cwru-form cwru-form-input,
cwru-form cwru-form-select {
  display: block !important;
}

cwru-form form {
  margin: 1rem 0;
}

cwru-form-header .header_text {
  background: var(--color-off-white);
  font-weight: var(--font-weight-bold);
  padding: 4px 12px;
  border-bottom: 5px solid var(--color-link-blue);
  font-size: 24px;
  max-width: 620px;
}

cwru-form form input[type='submit'],
cwru-form form input[type='reset'] {
  padding: 20px;
  font-weight: bold;
  line-height: 12px;
  border: none;
  background: var(--color-link-blue);
  color: var(--color-white);
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: inherit;
  margin: 0;
}
cwru-form form input[type='submit']:hover {
  background: var(--color-cwru-blue);
}
cwru-form form input[type='reset'] {
  background: var(--color-light-gray);
  color: var(--color-dark-gray);
}
cwru-form form input[type='reset']:hover {
  background: var(--color-cwru-blue);
  color: var(--color-white);
}
cwru-form #link_change_view {
  display: block;
}
cwru-form .form_question {
  box-sizing: border-box;
  margin: 0 0 1em 0;
  padding: 0;
  position: relative;
}
cwru-form a {
  color: var(--color-link-blue);
}
cwru-form a:hover {
  color: var(--color-cwru-blue) !important;
  text-decoration: underline !important;
}
cwru-form .form_label {
  display: block;
  padding-bottom: 3px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-dark-gray);
  cursor: pointer;
  margin: 0 0 0.1875em 0;
  padding-right: 4px;
  max-width: 100%;
}
cwru-form cwru-form-label .required {
  color: red;
}
cwru-form form input[type='text'],
cwru-form form select {
  box-sizing: border-box;
  max-width: 100%;
  vertical-align: middle;
}
cwru-form div.form_response input[type='text'],
cwru-form div.form_response select,
cwru-form div.form_response textarea {
  border: 1px solid var(--color-light-gray);
  border-radius: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.75);
  display: block;
  margin: 0;
  height: 48px;
  width: 100%;
  transition: box-shadow 0.45s, border-color 0.45s ease-in-out;
  padding: 6px 10px;
  font-size: 18px;
}
cwru-form-input[input-type='radio'] .form_response {
  display: flex !important;
  gap: 0.25rem;
  align-items: center;
}
cwru-form-input[input-type='radio'] .form_response cwru-form-label .form_label {
  padding: 0;
  margin: 0;
  font-weight: var(--font-weight-normal);
}
cwru-form-input[input-type='radio'] .form_response cwru-form-label .form_label .required {
  display: none;
}
cwru-form form select {
  height: auto;
  padding: 6px 6px;
}
cwru-form .form_response input:focus,
cwru-form .form_response select:focus,
cwru-form .form_response textarea:focus {
  border-color: #66afe9 !important;
  outline: 0 !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6) !important;
}
cwru-form p {
  margin: 1rem 0;
}
cwru-form form.horizontal cwru-form-question .form_question {
  display: flex !important;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}
cwru-form .horizontal .form-label {
  margin-right: 1.5rem;
}
cwru-form .horizontal div.form-response input[type='text'] {
  margin-bottom: 0;
  width: auto;
}
cwru-form .form-question-vertical {
  box-sizing: border-box;
  margin: 0 0 1em 0;
  padding: 0;
  position: relative;
}

cwru-form cwru-form-question[question-layout='vertical-question'] .form_question.vertical-question {
  display: block !important;
}
cwru-form cwru-form-question[question-layout='horizontal-buttons'] .form_question.horizontal-buttons {
  gap: 0.3rem;
}
cwru-form cwru-form-question[question-layout='vertical-buttons'] .form_question.vertical-buttons {
  display: block !important;
}
cwru-form cwru-form-question[question-layout='vertical-buttons'] .form_question.vertical-buttons cwru-form-input {
  margin-bottom: 0.5rem;
}
